export default [
     {
          path: '/student',
          name: 'Student',
          component: () => import("@/views/Page/Student/Student.vue"),
           meta: {
               title: '#Default# | Student',
          },
    },
    {
         path: '/student-profile',
         name: 'StudentProfile',
         component: () => import("@/views/Page/Student/StudentProfile.vue"),
         meta: {
             title: '#Default# | Student Profile',
         },
    },
    {
         path: '/student-section-selection',
         name: 'StudentSectionSelection',
         component: () => import("@/views/Page/Student/StudentSectionSelection.vue"),
         meta: {
             title: '#Default# | Section Selection',
             requiresStudentAuth: true,
         },
    },
    {
         path: '/student/absence-request',
         name: 'StudentAbsenceRequest',
         component: () => import("@/views/Page/Student/StudentAbsenceRequest.vue"),
         meta: {
             title: '#Default# | Absence Request',
             requiresStudentAuth: true,
         },
    },
    {
         path: '/student/withdrawal-request',
         name: 'StudentWithdrawalRequest',
         component: () => import("@/views/Page/Student/StudentWithdrawalRequest.vue"),
         meta: {
             title: '#Default# | Withdrawal Request',
             requiresStudentAuth: true,
         },
    }
];


